import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './DisclaimerPage.css';

const { FiAlertTriangle, FiShield } = FiIcons;

function DisclaimerPage() {
  return (
    <section className="disclaimer-page">
      <div className="page-intro">
        <span className="eyebrow"><SafeIcon icon={FiShield} /> Important information</span>
        <h1>Disclaimer</h1>
        <p>Please read these important limitations before using Bully-Free Malaysia.</p>
      </div>

      <article className="disclaimer-content">
        <p>
          Bully-Free Malaysia is a voluntary, community-driven initiative created
          to raise awareness and support individuals affected by bullying. We are
          not an emergency service, law enforcement agency, or professional
          counselling provider.
        </p>
        <p>
          While we strive to provide helpful information and connect individuals
          with relevant resources, we cannot guarantee the accuracy, availability,
          or outcomes of third-party services. Information shared on this platform
          may be subject to moderation and verification, but we cannot guarantee
          its completeness or accuracy.
        </p>
        <p>
          Users are responsible for their submissions and actions. Please do not
          share confidential, sensitive, or identifying information about yourself
          or others. We are not responsible for actions taken based on information
          provided by users or third parties, to the extent permitted by applicable
          law.
        </p>
        <div className="disclaimer-emergency">
          <SafeIcon icon={FiAlertTriangle} />
          <p>
            If you or someone else is in immediate danger, contact the appropriate
            authorities or call <a href="tel:999">999</a>.
          </p>
        </div>
        <p className="disclaimer-acknowledgement">
          By using this platform, you acknowledge and agree to these limitations.
        </p>
      </article>
    </section>
  );
}

export default DisclaimerPage;